import React from 'react'
import { Link } from 'react-router-dom'

function Footer({ color }) {
    return (
        <div className="text-center my-1 mt-10" >
            <Link to={"https://zeeqr.com/shopping"} className={`opacity-50 text-[${color ? color : '#000000'}] text-xs`} target="_blank">
                Powered by ZEEQR
            </Link>
        </div>
    )
}

export default Footer